import { render, staticRenderFns } from "./AccountCatalog.vue?vue&type=template&id=5fd5bf8d&scoped=true&"
import script from "./AccountCatalog.vue?vue&type=script&lang=js&"
export * from "./AccountCatalog.vue?vue&type=script&lang=js&"
import style0 from "./AccountCatalog.vue?vue&type=style&index=0&id=5fd5bf8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5bf8d",
  null
  
)

export default component.exports